import styles from 'partials/data-table/data-table.module.scss';

export const DataTableBody = ({ children }) => {
	return <div className={styles.body}>{children}</div>;
};
